import { Button, Link, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { useMaintenanceContainer } from './hooks/useMaintenanceContainer';

export const MaintenanceContainer: React.FC = () => {
	const {
		actions: { reload },
	} = useMaintenanceContainer();

	return (
		<div className="px-4 py-10 md:px-0">
			<div className="border-stroke-weaker container flex justify-center rounded-sm border border-solid">
				<div className="max-w-175">
					<div className="flex flex-col items-center justify-center pt-10 pb-20">
						<Text as="span" variant="heading" size="x-large" className="mt-8 text-center">
							🚧
						</Text>
						<Text as="h1" variant="heading" size="small" className="mt-8 mb-0 text-center">
							<Translate value="corgi.search.maintenance.title" />
						</Text>
						<Text as="p" variant="body" className="text-typography-weak mt-2 text-center text-balance wrap-break-word">
							<TranslateHtml
								value="corgi.search.maintenance.subtitle"
								replacements={{
									homepage_link: (
										<Link href="/?source_location=search-maintenance" variant="primary">
											<Translate value="corgi.search.maintenance.homepage" />
										</Link>
									),
								}}
							/>
						</Text>
						<Text as="p" variant="body" className="text-typography-weak mt-2 text-center wrap-break-word">
							<Translate value="corgi.search.maintenance.subtitle_thank_you" />
						</Text>
						<Button variant="secondary" size="small" className="mt-5" onClick={reload}>
							<Translate value="corgi.search.maintenance.refresh_button_label" />
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
